module.exports = __webpack_public_path__ + "img/outer-border.0b69f250.png";